/*eslint-disable*/
import React, { useState, useEffect, useContext } from 'react';
import Autosuggest from 'react-autosuggest';
import debounce from 'lodash/debounce';

import {
  CityData,
  CityListData,
  getSuggestions
} from '../../utils/cabAutoCompleteUtils';
import { Context } from '../../AppContext';

const getSuggestionValue = (suggestion: CityData) => {
  return suggestion.title;
};

const renderSuggestion = (suggestion: CityData, { query, isHighlighted }) => {
  var final_str = '<span class="latoBlack">' + suggestion.title + '</span>';
  return (
    <div className="makeFlex column">
      <p className="searchedResult font16 darkGreyText">
        <span
          className="sr_iata grayText latoBold"
          dangerouslySetInnerHTML={{ __html: final_str }}
        ></span>
      </p>
      <p>
        <span className="sr_city">{suggestion.subTitle}</span>{' '}
      </p>
    </div>
  );
};

const renderSectionTitle = (section: CityListData) => {
  return (
    <p className="rsw_sectionTitle font12 latoBold grayText">{section.title}</p>
  );
};

const getSectionSuggestions = (section: CityListData) => {
  return section.citieslist;
};
type AutoCompleteProps = {
  autoFocus: boolean;
  widget: number | null;
  travelFor: string;
  placeholder: string;
  closeCityPopup: () => void;
  onChange: (
    city: string,
    stn: string,
    placeId: string,
    cityCode?: string
  ) => Promise<void>;
};

const AutoComplete = React.memo(
  ({
    autoFocus,
    widget,
    travelFor,
    placeholder,
    closeCityPopup,
    onChange
  }: AutoCompleteProps) => {
    const { omniUrlArgs } = useContext(Context);
    const [value, setValue] = useState('');
    const [suggestions, setSuggestions] = useState<undefined | CityListData[]>(
      []
    );
    var input;

    useEffect(() => {
      input.focus();
    }, []);

    const onValueChange = (_, { newValue }) => {
      setValue(newValue);
    };

    const onSuggestionsFetchRequested = debounce(async ({ value }) => {
      // widget = 0 is from address, 1 is to address
      const suggestionsFetched = await getSuggestions(
        value,
        travelFor,
        widget,
        omniUrlArgs
      );
      setSuggestions(suggestionsFetched);
    }, 200);

    const onSuggestionsClearRequested = () => {
      setSuggestions([]);
    };

    const onSuggestionSelected = (event, { suggestion }) => {
      onChange(
        suggestion.title,
        suggestion.subTitle,
        suggestion.placeId,
        suggestion.cityCode
      );
    };

    const storeInputReference = autosuggest => {
      if (autosuggest !== null) {
        input = autosuggest.input;
      }
    };

    const inputProps = {
      placeholder,
      value,
      onChange: onValueChange
    };
    return (
      <div className="rsw_autocomplePopup">
        <div className="backArr" onClick={() => closeCityPopup()}>
          <span className="cm__leftArrow"></span>
        </div>
        <Autosuggest
          isHighlighted={true}
          multiSection={true}
          suggestions={suggestions}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          renderSectionTitle={renderSectionTitle}
          focusInputOnSuggestionClick={true}
          alwaysRenderSuggestions={true}
          getSectionSuggestions={getSectionSuggestions}
          onSuggestionSelected={onSuggestionSelected}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
          ref={storeInputReference}
        />
      </div>
    );
  }
);

export default AutoComplete;
